import UserService from "./UserService";

export { default } from './UserService';
export const userService = new UserService();
